import React, { Component } from "react";
import SharedViewProps from "../../../../../models/types/SharedViewProps";
import PaginatedDialogView from "../../components/PaginatedDialog/PaginatedDialogView";
import DialogMultilineTextInputView from "../../components/DialogBase/components/DialogMultilineTextInput/DialogMultilineTextInputView";
import TranslationView from "../../../../components/Translation/TranslationView";
import InjuryInfoViewStyle from "./InjuryInfoViewStyle";
import InjuryInfoViewState from "./InjuryInfoViewState";
import DialogDatePickerView from "../../components/DialogBase/components/DialogDatePicker/DialogDatePickerView";
import PaginatedDialogFooterView from "../../components/PaginatedDialog/components/PaginatedDialogFooter/PaginatedDialogFooterView";

export default class InjuryInfoView extends Component<SharedViewProps, InjuryInfoViewState> {

    private _style = new InjuryInfoViewStyle();

    constructor(props : SharedViewProps) {
        super(props);

        this.state = {
            startDate : '',
            endDate : '',
            medicheckComment : '',
            doctorComment : '',
            errors : {
                startDate : '',
            }
        }
    }

    private _onStartDateChange = (startDate : Date) => {
        const { errors } = this.state;

        errors.startDate = '';
        this.setState({ startDate : startDate.toUTCString(), errors });
    }

    private _onEndDateChange = (endDate : Date) => {
        this.setState({ endDate : endDate.toUTCString() });
    }

    private _onMedicheckCommentChange = (medicheckComment : string) => {
        this.setState({ medicheckComment });
    }

    private _onDoctorCommentChange = (doctorComment : string) => {
        this.setState({ doctorComment });
    }

    private _onSubmit = (done : () => void) => {
        const { startDate, endDate, medicheckComment, doctorComment, errors } = this.state;

        // Checks that all the required fields are filled
        if (!startDate) {
            errors.startDate = !startDate ? 'requiredField' : '';

            this.setState({ errors });
            done();

            return;
        }

        this.props.routeProps.history.push('billing-info', {
            request : { worker: this.props.routeProps.location.state, startDate, endDate, medicheckComment, doctorComment }
        });
    }

    render() {
        const { startDate, endDate, errors } = this.state;
        return (
            <PaginatedDialogView title='oneShotCheckRequest' subtitle='injuryInfo'>
                <div style={this._style.form}>
                    <div style={{ display : 'flex', justifyContent : 'space-between' }}>
                        <DialogDatePickerView
                            label='startDatePlaceholder'
                            onChange={this._onStartDateChange}
                            value={startDate}
                            maxDate={endDate}
                            style={{ width : '50%', marginRight : 15 }}
                            error={errors.startDate} />

                        <DialogDatePickerView
                            label='endDatePlaceholder'
                            minDate={startDate || new Date()}
                            onChange={this._onEndDateChange}
                            value={endDate}
                            style={{ width : '50%' }} />
                    </div>

                    <div style={{transform:'translateY(-15px)'}}>
                        <TranslationView style={this._style.label}>
                            medicheckCommentPlaceholder
                        </TranslationView>
                        <DialogMultilineTextInputView rows={2} onChange={this._onMedicheckCommentChange} />
                    </div>

                    <div style={{transform:'translateY(-15px)'}}>
                        <TranslationView style={this._style.label}>
                            doctorCommentPlaceholder
                        </TranslationView>
                        <DialogMultilineTextInputView rows={2} onChange={this._onDoctorCommentChange} />
                    </div>
                </div>

                <PaginatedDialogFooterView numberOfPages={5} currentPage={3} onSubmit={this._onSubmit} />
            </PaginatedDialogView>
        );
    }
}